export default __webpack_public_path__ + "images/dj-76f4cdf5eb6411038bc5994153148b04.svg";